module.exports = __webpack_public_path__ + "img/acounto_logo-02n.bd869faa.svg";